import React, { useState } from 'react'
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'
import { Link } from 'react-router-dom'
import { useAuth, useProtectedContent } from '../../../../context/AuthContext'

const ToolsDropdown = (props) => {
    const auth = useAuth()
    const showScheduledJobs = useProtectedContent(auth.permissions, 'scheduled_jobs')
    const showEncryptionTool = useProtectedContent(auth.permissions, 'encryption_tool')

    const [dropdownOpen, setDropdownOpen] = useState(false)

    const toggle = () => {
        setDropdownOpen(!dropdownOpen)
    }

    return (
        <Dropdown isOpen={dropdownOpen} toggle={toggle}>
            <DropdownToggle tag="a" onClick={toggle} data-toggle="dropdown" aria-expanded={dropdownOpen} className="nav-link dropdown-toggle dropdown-toggle-blue dropdown-toggle-right">
                Tools
            </DropdownToggle>

            <DropdownMenu className="dropdown-menu-dark">
                <Link className="dropdown-item" to="/searchId" onClick={toggle}>
                    Search Click ID
                </Link>
                {showScheduledJobs && (
                    <>
                        <DropdownItem divider className="m-0 dropdown-divider-dark" />
                        <Link className="dropdown-item" to="/admin/jobs" onClick={toggle}>
                            Scheduled Jobs
                        </Link>
                    </>
                )}
                {showScheduledJobs && (
                    <>
                        <DropdownItem divider className="m-0 dropdown-divider-dark" />
                        <Link className="dropdown-item" to="/apibuilder" onClick={toggle}>
                            API Builder
                        </Link>
                    </>
                )}
                <>
                    <DropdownItem divider className="m-0 dropdown-divider-dark" />
                    <Link className="dropdown-item" to="/apiIntegrationsHistory" onClick={toggle}>
                        API Integrations History
                    </Link>
                </>
                <>
                    <DropdownItem divider className="m-0 dropdown-divider-dark" />
                    <Link className="dropdown-item" to="/apiLeadsReport" onClick={toggle}>
                        API Leads Report
                    </Link>
                </>
                <>
                    <DropdownItem divider className="m-0 dropdown-divider-dark" />
                    <Link className="dropdown-item" to="/apiLeadsReportTesting" onClick={toggle}>
                        API Leads Report (Testing)
                    </Link>
                </>
                <>
                    <DropdownItem divider className="m-0 dropdown-divider-dark" />
                    <Link className="dropdown-item" to="/manualPostbackFiring" onClick={toggle}>
                        Manual Postback Firing
                    </Link>
                </>
                {showEncryptionTool && (
                    <>
                        <DropdownItem divider className="m-0 dropdown-divider-dark" />
                        <Link className="dropdown-item" to="/encryptionTool" onClick={toggle}>
                            Encrypt/Decrypt Data
                        </Link>
                    </>
                )}
            </DropdownMenu>
        </Dropdown>
    )
}

export default ToolsDropdown
